import { useLingui } from '@lingui/react/macro';

import {
  FilterCheckboxItem,
  FilterItemNoResults,
  FiltersList,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import IconValidation from '@/icons/Validation.svg';

import { useFilters } from '../FiltersState';
import { useWarrantyTypeOptions } from '../utils';

export const FiltersWarrantyType = () => {
  const { t, i18n } = useLingui();

  const {
    warrantyTypes: { warrantyTypes, setWarrantyTypes },
  } = useFilters();

  const warrantyTypeOptions = useWarrantyTypeOptions();

  const toggleWarrantyType = (warrantyType: (typeof warrantyTypes)[number]) => {
    if (warrantyTypes.includes(warrantyType)) {
      setWarrantyTypes(warrantyTypes.filter((wt) => wt !== warrantyType));
    } else {
      setWarrantyTypes([...warrantyTypes, warrantyType]);
    }
  };

  const options =
    warrantyTypeOptions.length > 0 ? (
      warrantyTypeOptions.map(({ id, label }) => (
        <FilterCheckboxItem key={id} id={id} label={i18n._(label)} />
      ))
    ) : (
      <FilterItemNoResults />
    );

  return (
    <FiltersSubMenu
      id="warranty-type"
      icon={<IconValidation />}
      label={t({ id: 'requests.filters.warranty-type.label', message: 'Warranty type' })}
      count={warrantyTypes.length}
    >
      <FiltersList
        ariaLabel={t({ id: 'requests.filters.warranty-type.label', message: 'Warranty type' })}
        values={warrantyTypes}
        onChange={toggleWarrantyType}
      >
        {options}
      </FiltersList>
    </FiltersSubMenu>
  );
};
